import React, { useState, useMemo, useRef } from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { withStyles, Tooltip, IconButton, Typography } from '@material-ui/core';
import { hasPermission, createHistory, hasAtLeastOnePermission } from '../../sc-utilities';
import OperatingSystemList from './OperatingSystemList';
import { FindInPage } from '@material-ui/icons';

const styles = theme => ({
    root: {
        width: `100%`,
        height: 'auto',
        paddingLeft: theme.spacing(-1),
        [theme.breakpoints.down('sm')]: {
            padding: 0,
            margin: 0,
            width: '100%'
        }
    }
});

const OperatingSystem = props => {
    const tableRef = useRef();
    const { classes, columns, translations, permissions } = props;
    const [redirectOptions, setRedirectOptions] = useState({ redirect: false, operatingSystemID: null, redirectPath: '' });

    let visible = columns && columns['OperatingSystem'];
    const tableColumns = useMemo(() => {
        return [{
            title: translations["action"] || "Action", field: 'Action',
            hidden: visible ? visible['Action'] : false,
            cellStyle: { minWidth: 100, maxWidth: 100 },
            filtering: false,
            render: rowData => <>
                {
                    hasPermission(permissions, 'operating_system_load') ? <Tooltip title={translations["operating_system_details"] || "Operating system details"}>
                        <IconButton value={rowData.OperatingSystemID} aria-label={translations["operating_system_details"] || "Operating system details"} onClick={() => redirectHandler(`/settings/operating-system/edit?operatingSystemID=${rowData.OperatingSystemID}`)}>
                            <FindInPage />
                        </IconButton>
                    </Tooltip> : ''
                }
            </>
        },
        {
            title: translations["short_name"] || 'Short name', field: 'Name',
            hidden: visible ? visible['Name'] : false,
            filtering: true,
            render: rowData => {
                return <Typography variant={'caption'}>{rowData.Name ? rowData.Name : translations['short_not_assigned'] || 'n/a'}</Typography>;
            }
        },
        {
            title: translations["long_name"] || 'Long name', field: 'LongName',
            hidden: visible ? visible['LongName'] : false,
            filtering: true,
            render: rowData => {
                return <Typography variant={'caption'}>{rowData.LongName ? rowData.LongName : translations['short_not_assigned'] || 'n/a'}</Typography>;
            }
        },
        {
            title: translations["system"] || 'System', field: 'System',
            hidden: visible ? visible['System'] : false,
            filtering: true,
            lookup: { '1': translations["system"] || 'System', '0': translations["custom"] || 'Custom' },
            defaultFilter: ['0', '1'],
            render: rowData => {
                return <Typography variant={'caption'}>{!rowData.CustomerID ? translations["system"] || 'System' : translations["custom"] || 'Custom'}</Typography>;
            }
        }
        ];
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [classes, translations, visible])

    if (!hasAtLeastOnePermission(permissions, ['operating_system_load'])) {
        tableColumns.shift();
    }

    const redirectHandler = (path, operatingSystemID = null) => {
        createHistory();
        setRedirectOptions({ redirect: true, operatingSystemID: operatingSystemID, redirectPath: path })
    };

    if (redirectOptions.redirect) {
        return <Redirect to={redirectOptions.redirectPath} />;
    }

    return (
        <div className={classes.root}>
            {hasPermission(permissions, 'operating_system_list') ?
                <OperatingSystemList
                    tableColumns={tableColumns}
                    redirectHandler={redirectHandler}
                    tableRef={tableRef}
                />
                :
                null}
        </div>
    );
};

const mapStateToProps = state => {
    return {
        translations: state.translate && state.translate.translations ? state.translate.translations.activeTranslations || {} : {},
        columns: state.core.login.userSettings ? state.core.login.userSettings.Columns : null,
        permissions: state?.core?.login?.permissions || []
    };
};

export default connect(
    mapStateToProps,
    null
)(withStyles(styles)(OperatingSystem));
